import {SoftDeleteEntity} from "./soft-delete-entity";
import {Company} from "./company";

export class PartnerWallet extends SoftDeleteEntity {
  company: Company;
  companyId: number;

  balance: number;
  createDate: Date;
  updateDate: Date;
  walletNumber: string;
  walletIban: string;
  walletBic: string;
  revolutAccountId: string;

  customName: string;
  currencyCode: number;
  public notificationEmail: string|null;
  senderFilter: string|null;

  isClosed: boolean;
  closeDate: Date|null;

  loadFee: number;

  brandReferralCode: string|null;

}


